// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-templates-guide-download-js": () => import("./../src/templates/guide-download.js" /* webpackChunkName: "component---src-templates-guide-download-js" */),
  "component---src-templates-squeeze-pages-sector-site-js": () => import("./../src/templates/squeeze-pages/sector-site.js" /* webpackChunkName: "component---src-templates-squeeze-pages-sector-site-js" */)
}

